import TrainMarker from './TrainMarker';

export default TrainMarker;
